import { render, staticRenderFns } from "./WcLoadersCardList.vue?vue&type=template&id=769a7a9e&lang=pug&"
import script from "./WcLoadersCardList.vue?vue&type=script&lang=js&"
export * from "./WcLoadersCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports